import "react-app-polyfill/ie11";
import React, { useState, useEffect } from "react";
import Root from "./client_customizations/containers/Root/Root";
import { BrowserRouter as Router } from "react-router-dom";
import { IntlProvider } from "react-intl";
import {createRoot } from 'react-dom/client';
import * as serviceWorker from "./serviceWorker";
import "./utils/polyfills";
import messages_en from "./client_customizations/translations/en.js";
import messages_esp from "./client_customizations/translations/esp.js";

const App = () => {
  const [language, setLanguage] = useState("EN");
    const messages = {
      EN: messages_en,
      ES: messages_esp,
    };

   const changeLanguage = (language) => {
     localStorage.setItem('language', language);
     setLanguage(language);
   };

   useEffect(() => {
     let key = localStorage.getItem('language');

     if (key) {
       setLanguage(key);
     }
   }, []);

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <Router>
        <Root language={language} changeLanguage={changeLanguage} />
      </Router>
    </IntlProvider>
  );
};

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
